import { DataBean } from "../DataBean";

export class GuideProjectLeft extends DataBean {

    public async getTransportGuideProjectLeft(idProject: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.Movement_getTransportGuideProjectLeft_Number", [idProject]);
    }

}